(function () {

    function hideOpenedMenus() {
        for (let menu of document.getElementsByClassName("component-dropdown--opened")) {
            menu.classList.remove('component-dropdown--opened');
        }
    }

    function switchDropdown(buttonClass, dropdownClass, align="right") {
        let dropdownEl = document.getElementsByClassName(dropdownClass)[0];
        let show = !dropdownEl.classList.contains("component-dropdown--opened");

        hideOpenedMenus();

        let div_el = document.getElementsByClassName(buttonClass);
        let div_el_bar = document.getElementsByClassName("template-HB__header")[0];
        let rect = div_el[0].getBoundingClientRect();
        let x = rect.left + div_el[0].offsetWidth;
        let y = div_el_bar.offsetHeight;

        dropdownEl.style.top = y + "px";

        if (!show) {
            dropdownEl.classList.add("component-dropdown--closing");
            setTimeout(function () {
                dropdownEl.classList.remove("component-dropdown--closing");
            }, 500);
        }

        if (show) {
            dropdownEl.classList.add('component-dropdown--opened');
        } else {
            dropdownEl.classList.remove('component-dropdown--opened');
        }

        if (align == "right") {
            x -= dropdownEl.offsetWidth;
        }

        if (align == "left") {
            x = rect.left;
        }
        
        dropdownEl.style.left = x + "px";
    }

    function initMenus() {

        document.getElementsByClassName("programs-dropdown")[0].addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            switchDropdown("programs-dropdown", "component-dropdown--programs", "left");
        });

        document.getElementsByClassName("accountbar__languages")[0].addEventListener("click", function (e) {
            e.stopPropagation();
            switchDropdown("accountbar__languages", "component-dropdown--languages");
        });

        if(document.getElementsByClassName("accountbar__user_profile").length){
            document.getElementsByClassName("accountbar__user_profile")[0].addEventListener("click", function (e) {
                e.stopPropagation();
                switchDropdown("accountbar__user_profile", "component-dropdown--user-info");
            });
        }

        for (let drop of document.getElementsByClassName("component-dropdown")) {
            drop.addEventListener("click", function (e) { e.stopPropagation(); });
        }

        document.body.addEventListener("click", function (e) {
            hideOpenedMenus();
        });
    }

    initMenus();
})();
